import { withInstall } from '@sgui-plus/utils'
import Avatar from './src/avatar.vue'

export const SgAvatar = withInstall(Avatar)
export default SgAvatar

export * from './src/avatar'
export type { AvatarInstance } from './src/instance'
